;(() => {
  const dialog = document.getElementById('wren-community-checkout-offer');
  if (!dialog) return;
  const installKey = Symbol.for('wren.community.checkoutOffer');
  if (window[installKey]) return;
  window[installKey] = true;
  const eligible = dialog.dataset.communityEligible === 'true';
  const redeemed = dialog.dataset.communityRedeemed === 'true';
  const variant = eligible ? 'member_reminder' : 'join';
  const seenKey = `wren-community-checkout-offer-v3-${variant}`;
  const returnKey = 'wren-community-cart-return-v1';
  const attributionKey = 'wren-community-offer-action-v1';
  const formId = '6ad58027e98db685382204f7';
  const lifetime = 2 * 60 * 60 * 1000;
  const checkoutSelector = 'button.cart__checkout-button[name="checkout"][form="cart"], #mini-cart form.mini-cart button[name="checkout"]';
  const communitySelector = 'main.architechpro-mega-community-body';
  let seen = false;
  let checkoutButton = null;
  let returnFocus = true;
  let replaying = false;
  let surface = 'cart_page';
  let submitted = false;
  const readState = (storage, key) => {
    try {
      const state = JSON.parse(storage.getItem(key));
      if (state && Number.isFinite(state.expires) && state.expires > Date.now() && state.expires <= Date.now() + lifetime) return state;
      storage.removeItem(key);
    } catch {}
    return null;
  };
  const previewId = () => {
    const id = new URLSearchParams(window.location.search).get('preview_theme_id');
    return id && /^\d{1,20}$/.test(id) ? id : null;
  };
  const production = () => window.Shopify?.theme?.role === 'main' && !window.Shopify.designMode && !new URLSearchParams(window.location.search).has('preview_theme_id') && !document.getElementById('PBarNextFrame');
  const analyticsAllowed = () => {
    try { return production() && window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true; } catch { return false; }
  };
  const track = (name, eventSurface = surface) => {
    if (!analyticsAllowed() || typeof window.Shopify?.analytics?.publish !== 'function') return;
    try {
      const result = window.Shopify.analytics.publish(`wrenlife:community_${name}`, { offer: 'checkout_v1', surface: eventSurface, variant });
      if (result?.catch) result.catch(() => {});
    } catch {}
  };
  const clearAttribution = () => {
    try { sessionStorage.removeItem(attributionKey); } catch {}
    document.querySelectorAll('[data-wren-community-attribution]').forEach(input => input.remove());
  };
  const rememberAction = action => {
    if (!analyticsAllowed()) return;
    try {
      const previous = readState(sessionStorage, attributionKey);
      sessionStorage.setItem(attributionKey, JSON.stringify({ action: previous?.action === 'join' ? 'join' : action, expires: Date.now() + lifetime }));
    } catch {}
  };
  const applyAttribution = form => {
    if (!form) return;
    form.querySelectorAll('[data-wren-community-attribution]').forEach(input => input.remove());
    let state;
    if (analyticsAllowed()) {
      try { state = readState(sessionStorage, attributionKey); } catch {}
    } else {
      clearAttribution();
    }
    const action = state && ['join', 'continue', 'dismiss'].includes(state.action) ? state.action : '';
    const values = { __wrenlife_community_offer: action ? 'checkout_v1' : '', __wrenlife_community_action: action };
    Object.entries(values).forEach(([key, value]) => {
      const name = `attributes[${key}]`;
      let input = Array.from(form.elements).find(element => element.name === name);
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = name;
        input.setAttribute('data-wren-community-attribution', '');
        form.append(input);
      }
      input.value = value;
    });
  };
  const loadPrivacy = () => {
    if (!production() || window.Shopify?.customerPrivacy || typeof window.Shopify?.loadFeatures !== 'function') return;
    try { window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {}); } catch {}
  };
  loadPrivacy();
  document.addEventListener('visitorConsentCollected', () => { if (!analyticsAllowed()) clearAttribution(); });
  window.addEventListener('omnisendForms', event => {
    const detail = event.detail;
    if (submitted || detail?.form?.id !== formId || (detail.type || detail.eventName) !== 'submit') return;
    submitted = true;
    track('signup_submit');
  });
  let cartPath = '/cart';
  try {
    const route = new URL(dialog.dataset.cartUrl, window.location.origin);
    if (route.origin === window.location.origin && /\/cart\/?$/.test(route.pathname)) cartPath = route.pathname;
  } catch {}
  const rememberCart = () => {
    const intent = { expires: Date.now() + lifetime };
    const id = previewId();
    if (id) intent.preview = id;
    try { sessionStorage.setItem(returnKey, JSON.stringify(intent)); } catch {}
  };
  let returnIntent;
  try { returnIntent = readState(sessionStorage, returnKey); } catch {}
  if (returnIntent && window.location.pathname.replace(/\/$/, '') === cartPath.replace(/\/$/, '')) {
    track('cart_return', 'cart_page');
    try { sessionStorage.removeItem(returnKey); } catch {}
    returnIntent = null;
  }
  const mountCartReturn = () => {
    if (!returnIntent || returnIntent.expires <= Date.now()) return;
    const root = document.querySelector(communitySelector);
    const template = document.getElementById('wren-community-cart-return-template');
    if (!root || !template || root.querySelector('.wren-community-cart-return')) return;
    const content = template.content.cloneNode(true);
    const link = content.querySelector('[data-community-cart-return]');
    const id = previewId() || (/^\d{1,20}$/.test(returnIntent.preview || '') ? returnIntent.preview : null);
    link.href = cartPath + (id ? `?preview_theme_id=${id}` : '');
    root.prepend(content);
  };
  if (returnIntent) {
    mountCartReturn();
    const observer = new MutationObserver(mountCartReturn);
    observer.observe(document.body, { childList: true, subtree: true });
    window.addEventListener('pagehide', () => observer.disconnect(), { once: true });
  }
  try { seen = sessionStorage.getItem(seenKey) === '1'; } catch {}
  const remember = () => {
    seen = true;
    try { sessionStorage.setItem(seenKey, '1'); } catch {}
  };
  const usableCheckout = button => button instanceof HTMLButtonElement && button.matches(checkoutSelector) && button.isConnected && !button.disabled && button.form;
  const hasOneTimeItem = form => Boolean(form.querySelector('[data-wren-purchase-type="one-time"]'));
  const hasCommunityDiscount = button => eligible && Array.from(
    button.closest('#main-cart-footer, #mini-cart')?.querySelectorAll('cart-discount button[is="discount-remove"][data-discount]') || []
  ).some(control => (control.getAttribute('data-discount') || '').trim().toUpperCase() === 'WRENLIFE-COMMUNITY15');
  const close = focus => {
    returnFocus = focus;
    if (dialog.open) dialog.close();
  };
  const dismiss = () => {
    if (!dialog.open) return;
    track('offer_dismiss');
    rememberAction('dismiss');
    close(true);
  };
  const continueCheckout = () => {
    track('offer_continue');
    rememberAction('continue');
    const original = checkoutButton;
    close(false);
    const current = usableCheckout(original) ? original : Array.from(document.querySelectorAll(checkoutSelector)).find(button => usableCheckout(button) && button.getClientRects().length);
    if (!current) return;
    applyAttribution(current.form);
    replaying = true;
    try { current.click(); } finally { replaying = false; }
  };
  const openSignup = () => {
    window.omnisend = window.omnisend || [];
    window.omnisend.push(['openForm', formId]);
  };
  const showSignupFallback = () => {
    if (!usableCheckout(checkoutButton)) return;
    const target = checkoutButton.closest('.button-container, .cart__ctas') || checkoutButton;
    let notice = target.parentElement.querySelector('[data-community-signup-fallback]');
    if (!notice) {
      const template = document.getElementById('wren-community-signup-fallback-template');
      if (!template) return;
      notice = template.content.firstElementChild.cloneNode(true);
      notice.querySelector('[data-community-signup-retry]').addEventListener('click', openSignup);
      target.before(notice);
    }
    notice.focus({ preventScroll: true });
    notice.scrollIntoView({ block: 'nearest' });
  };
  dialog.querySelector('[data-community-offer-close]').addEventListener('click', dismiss);
  dialog.querySelector('[data-community-offer-continue]').addEventListener('click', continueCheckout);
  dialog.querySelector('[data-community-offer-join]')?.addEventListener('click', () => {
    rememberCart();
    track('offer_join');
    rememberAction('join');
    close(false);
    showSignupFallback();
    openSignup();
  });
  dialog.addEventListener('cancel', event => { event.preventDefault(); dismiss(); });
  dialog.addEventListener('close', () => {
    if (returnFocus && usableCheckout(checkoutButton)) checkoutButton.focus({ preventScroll: true });
  });
  dialog.addEventListener('click', event => {
    event.stopPropagation();
    if (event.target !== dialog) return;
    const box = dialog.getBoundingClientRect();
    if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dismiss();
  });
  const openOffer = (event, button) => {
    if (!usableCheckout(button) || event.defaultPrevented) return;
    if (seen || replaying || redeemed || !hasOneTimeItem(button.form) || hasCommunityDiscount(button)) { applyAttribution(button.form); return; }
    if (!(dialog instanceof HTMLDialogElement) || typeof dialog.showModal !== 'function') return;
    try { dialog.showModal(); } catch { return; }
    event.preventDefault();
    event.stopImmediatePropagation();
    checkoutButton = button;
    surface = button.closest('#mini-cart') ? 'cart_drawer' : 'cart_page';
    returnFocus = true;
    remember();
    track('offer_view');
    dialog.querySelector('#wren-community-offer-title').focus({ preventScroll: true });
  };
  document.addEventListener('click', event => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    openOffer(event, event.target.closest?.(checkoutSelector));
  }, true);
  document.addEventListener('submit', event => openOffer(event, event.submitter), true);
})();
